import React, { useState } from "react";

const NotesItem = (props) => {
    const { label, checked, setChecked, isDisabled = false } = props;
    const [isChecked, setIsChecked] = useState(checked);
    const handleChange = () => {
        setChecked(!isChecked);
        setIsChecked(!isChecked)
    }
    return (
        <div className="meetingCheckboxWrapper d-flex align-items-center">
            <input id="checkbox" type="checkbox" className="meetingCheckboxInput me-1 cursor-pointer" disabled={isDisabled} checked={isChecked} onChange={handleChange} />
            <label htmlFor="" className='grey36Color text-sm-400 cursor-pointer'>{label}</label>
        </div>
    );
}

export default NotesItem;